(() => {
    class ManageCampaignTemplateVoucherController {
        NewInstanceScriptEditor;
        userContext;
        /**
         * @type {CampaignTemplate}
         */
        campaignTemplate;
        /**
         * @type {CampaignVoucherTemplate}
         */
        voucher;
        hasVoucher;
        voucherSetUp;

        constructor(
            $scope,
            $compile,
            DTOptionsBuilder,
            DTColumnBuilder,
            $q,
            CampaignDesignerService,
            ErrorService,
            $state,
            notify,
            renderer
        ) {
            this.$scope = $scope;
            this.$compile = $compile;
            this.DTOptionsBuilder = DTOptionsBuilder;
            this.DTColumnBuilder = DTColumnBuilder;
            this.$q = $q;
            this.CampaignDesignerService = CampaignDesignerService;
            this.ErrorService = ErrorService;
            this.$state = $state;
            this.notify = notify;
            this.renderer = renderer;
        }

        $onInit() {
            if (!this.campaignTemplate) {
                throw new Error(`campaignTemplate is required`);
            }
            if (this.campaignTemplate && !Array.isArray(this.campaignTemplate.Vouchers)) {
                this.campaignTemplate.Vouchers = [];
            }

            this.waitForEditorToInitialiseThen(() => {
                this.setupVoucherModel();
                this.hasVoucher = !!this.campaignTemplate.Vouchers.length;
                this.$scope.$apply();
                this.voucherSetUp = true;
            });
        }

        waitForEditorToInitialiseThen(fn) {
            if (this.NewInstanceScriptEditor && typeof this.NewInstanceScriptEditor.setValue === "function") {
                fn();
                return;
            }
            window.setTimeout(this.waitForEditorToInitialiseThen.bind(this, fn), 50);
        }

        goToNextStep() {
            return this.saveVoucherAndThen(() => {
                this.$state.go(
                    window.Dashboard.helpers.stateHelper.getParentState(
                        this.$state.current.name
                    ) + ".comms", {
                        brandId: this.userContext.BrandId,
                        CampaignTemplateGuid: this.campaignTemplate.TemplateGuid
                    });
            });
        }

        goToPreviousStep() {
            return this.saveVoucherAndThen(() => {
                if (this.campaignTemplate.CampaignLevelId === Dashboard.Models.Lookups.CampaignLevels.Brand) {
                    // If this is a brand level campaign, skip store associations
                    this.$state.go(
                        window.Dashboard.helpers.stateHelper.getParentState(
                            this.$state.current.name
                        ), {
                            brandId: this.userContext.BrandId,
                            CampaignTemplateGuid: this.campaignTemplate.TemplateGuid
                        });

                } else {
                    this.$state.go(
                        window.Dashboard.helpers.stateHelper.getParentState(
                            this.$state.current.name
                        ) + ".stores", {
                            brandId: this.userContext.BrandId,
                            CampaignTemplateGuid: this.campaignTemplate.TemplateGuid
                        });
                }
            });
        }

        saveVoucherAndThen(fn) {
            this.saveVoucher()
                .then(fn)
                .catch(e => console.error(e))
        }

        saveVoucher() {
            if (!this.hasVoucher) {
                if (this.voucher.Id) {
                    return this.removeVoucher();
                }
                return this.$q.resolve();
            }
            this.voucher.NewInstanceScript = this.NewInstanceScriptEditor.getValue();
            this.voucher.CampaignTemplateId = this.campaignTemplate.Id;

            const validationPassed = this.voucher.Validate(this.ErrorService);

            if (!validationPassed) {
                return this.$q.reject("voucher validation failure - voucher not saved");
            }
            this.$scope.$root.isLoading = true;

            return this.CampaignDesignerService.saveCampaignTemplateVoucher(
                this.campaignTemplate.TemplateGuid,
                this.voucher
            ).then(result => {
                    this.voucher.Id = result.data;

                    this.campaignTemplate.Vouchers.splice(0, this.campaignTemplate.Vouchers.length);
                    this.campaignTemplate.Vouchers.push(this.voucher);

                    this.notify.success("The campaign voucher was successfully saved");
                }
            ).catch(err => {
                this.ErrorService.showError(
                    "An error occurred while saving the voucher",
                    err
                );
            }).finally(() => {
                this.$scope.$root.isLoading = false;
            });
        }

        setupVoucherModel() {
            this.voucher = new window.Dashboard.Models.CampaignVoucherTemplate();
            if (this.campaignTemplate.Vouchers[0]) {
                this.voucher.initialiseCampaignVoucherTemplate(
                    this.campaignTemplate.Vouchers[0]
                );
            }
            if (this.NewInstanceScriptEditor) {
                this.NewInstanceScriptEditor.setValue(this.voucher.NewInstanceScript);
            }
        }

        removeVoucher() {
            this.$scope.$root.isLoading = true;

            return this.CampaignDesignerService.removeCampaignTemplateVoucher(
                this.campaignTemplate.TemplateGuid,
                this.voucher.Id
            ).then(() => {
                    this.campaignTemplate.Vouchers = _.reject(
                        this.campaignTemplate.Vouchers, voucher => {
                            return voucher.Id === this.voucher.Id;
                        });
                    this.notify.success("The campaign voucher was successfully removed");
                }
            ).catch(err => {
                this.ErrorService.showError(
                    "An error occurred while removing the voucher",
                    err
                );
            }).finally(() => {
                this.$scope.$root.isLoading = false;
            });
        }
    }

    angular
        .module("dashboard")
        .component("manageCampaignTemplateVouchers", {
            templateUrl: "components/campaigndesigner/managecampaigntemplates/voucherssetup/campaigntemplatevoucherssetup.5b5e6b9b.html",
            bindings: {
                campaignTemplate: "=",
                userContext: "<"
            },
            controller: [
                "$scope",
                "$compile",
                "DTOptionsBuilder",
                "DTColumnBuilder",
                "$q",
                "CampaignDesignerService",
                "ErrorService",
                "$state",
                "notify",
                "DataTablesRenderer",
                ManageCampaignTemplateVoucherController ]
        });
})();
